import { render } from "./SystemPushMassages.vue?vue&type=template&id=3d979a78&scoped=true"
import script from "./SystemPushMassages.vue?vue&type=script&lang=js"
export * from "./SystemPushMassages.vue?vue&type=script&lang=js"

import "./SystemPushMassages.vue?vue&type=style&index=0&id=3d979a78&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d979a78"]])

export default __exports__